import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Link from 'next/link'

import ButtonText from '@segment/matcha/components/ButtonText'

import { ChevronLeftIcon } from '@segment/matcha/components/Icons/Common'

import HeroBase, * as HeroRecipe from '@segment/matcha/recipes/Hero'
import * as CopyText from '@segment/matcha/recipes/CopyText'

import { trackButtonClick } from '@segment/tracking/scripts'

import getAbsoluteUrl from '@segment/utils/getAbsoluteUrl'

import { usePageConfig } from '@segment/contexts/page'

const copy = {
  heading: `Customer Data Platform pricing`,
  description: `Unlock the potential of your engineering, marketing, and product teams with our customer data platform. Discover pricing options and learn more from Twilio Segment.`,
}

const button = {
  text: `Which plan is right for you?`,
  url: `#compare-plans`,
}

const Hero: FC<PropsWithChildren> = () => {
  const pageConfig = usePageConfig()
  return (
    <Wrapper>
      <LinkWrapper>
        <Link href={getAbsoluteUrl(`/pricing`, pageConfig)}>
          <ButtonText tag="span" size="medium" iconStart={ChevronLeftIcon}>
            All pricing
          </ButtonText>
        </Link>
      </LinkWrapper>
      <StyledHeroBase variant="centered">
        <HeroRecipe.Copy>
          <CopyText.Heading variant="h1" tag="h1">
            {copy.heading}
          </CopyText.Heading>
          <CopyText.Description tag="p">{copy.description}</CopyText.Description>
          <HeroRecipe.Contents>
            <ButtonText
              href={button.url}
              onClick={() =>
                trackButtonClick({
                  buttonText: button.text,
                  targetUrl: button.url,
                  buttonId: `pricing-cdp-page-hero-compare`,
                })
              }
            >
              {button.text}
            </ButtonText>
          </HeroRecipe.Contents>
        </HeroRecipe.Copy>
      </StyledHeroBase>
    </Wrapper>
  )
}

const Wrapper = styled.header`
  background-color: ${({ theme }) => theme.palette.twilio.mint[10]};
`
const StyledHeroBase = styled(HeroBase)`
  ${HeroRecipe.Wrapper} {
    padding-bottom: 0px;
    gap: 0;
  }
`

const LinkWrapper = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 40px 40px 0 40px;
`

export default Hero
